export const PROVINCE_NAMES = {
  "서울특별시": { en: "Seoul", ja: "ソウル特別市", zh: "首尔特别市" },
  "부산광역시": { en: "Busan", ja: "釜山広域市", zh: "釜山广域市" },
  "대구광역시": { en: "Daegu", ja: "大邱広域市", zh: "大邱广域市" },
  "인천광역시": { en: "Incheon", ja: "仁川広域市", zh: "仁川广域市" },
  "광주광역시": { en: "Gwangju", ja: "光州広域市", zh: "光州广域市" },
  "대전광역시": { en: "Daejeon", ja: "大田広域市", zh: "大田广域市" },
  "울산광역시": { en: "Ulsan", ja: "蔚山広域市", zh: "蔚山广域市" },
  "세종특별자치시": { en: "Sejong", ja: "世宗特別自治市", zh: "世宗特别自治市" },
  "경기도": { en: "Gyeonggi-do", ja: "京畿道", zh: "京畿道" },
  "강원특별자치도": { en: "Gangwon State", ja: "江原特別自治道", zh: "江原特别自治道" },
  "강원도": { en: "Gangwon-do", ja: "江原道", zh: "江原道" },
  "충청북도": { en: "Chungcheongbuk-do", ja: "忠清北道", zh: "忠清北道" },
  "충청남도": { en: "Chungcheongnam-do", ja: "忠清南道", zh: "忠清南道" },
  "전라북도": { en: "Jeollabuk-do", ja: "全羅北道", zh: "全罗北道" },
  "전북특별자치도": { en: "Jeonbuk State", ja: "全北特別自治道", zh: "全北特别自治道" },
  "전남광주통합특별시": { en: "Jeonnam/Gwangju", ja: "全羅南道/光州", zh: "全罗南道/光州" },
  "전라남도": { en: "Jeollanam-do", ja: "全羅南道", zh: "全罗南道" },
  "경상북도": { en: "Gyeongsangbuk-do", ja: "慶尚北道", zh: "庆尚北道" },
  "경상남도": { en: "Gyeongsangnam-do", ja: "慶尚南道", zh: "庆尚南道" },
  "제주특별자치도": { en: "Jeju Island", ja: "済州特別自治道", zh: "济州特别自治道" }
};

const SERVICE_DICTIONARY = [
  { match: /(짐보관|luggage|bogwan)/i, en: "Luggage Storage", ja: "手荷物預かり", zh: "行李寄存" },
  { match: /(휴게공간|휴게실|hyuge|rest lounge)/i, en: "Rest Lounge", ja: "休憩スペース", zh: "休息区" },
  { match: /(네트워킹|공유공간|working|workspace)/i, en: "Networking & Workspace", ja: "ワークスペース", zh: "共享空间" },
  { match: /(외국어|통역|해설|interpretation|guide)/i, en: "Multilingual Guide", ja: "外国語通訳案内", zh: "多语种导览与翻译" },
  { match: /(와이파이|wifi|wi-fi|인터넷)/i, en: "Free Wi-Fi", ja: "無料Wi-Fi", zh: "免费Wi-Fi" },
  { match: /(휠체어|유모차|wheelchair|stroller)/i, en: "Wheelchair & Stroller Rental", ja: "車椅子・ベビーカー貸出", zh: "轮椅/婴儿车租借" },
  { match: /(스탬프|stamp)/i, en: "Stamp Tour", ja: "スタンプラリー", zh: "盖章打卡" },
  { match: /(수유실|nursing)/i, en: "Nursing Room", ja: "授乳室", zh: "母婴室" },
  { match: /(기념품|특산물|souvenir)/i, en: "Souvenirs & Local Gifts", ja: "お土産・特産品", zh: "纪念品与特产" },
  { match: /(관광지도|안내책자|홍보물|map|brochure)/i, en: "Travel Maps & Guides", ja: "観光マップ・パンフレット", zh: "旅游地图与宣传册" },
  { match: /(충전|charging)/i, en: "Device Charging", ja: "スマホ充電", zh: "手机充电" },
  { match: /(우산|umbrella)/i, en: "Umbrella Rental", ja: "傘貸出", zh: "雨伞租借" }
];

const OPERATOR_TERMS = [
  { match: /관광협회|관광협/i, en: "Tourism Association", ja: "観光協会", zh: "旅游协会" },
  { match: /관광공사/i, en: "Tourism Organization", ja: "観光公社", zh: "旅游发展局" },
  { match: /문화관광재단|문화재단/i, en: "Culture & Tourism Foundation", ja: "文化観光財団", zh: "文化旅游基金会" },
  { match: /시설관리공단|시설공단/i, en: "Facilities Management Corp", ja: "施設管理公団", zh: "设施管理公团" },
  { match: /시청/i, en: "City Hall", ja: "市役所", zh: "市政府" },
  { match: /구청/i, en: "District Office", ja: "区役所", zh: "区政府" },
  { match: /군청/i, en: "County Office", ja: "郡庁", zh: "郡政府" },
  { match: /도청/i, en: "Provincial Office", ja: "道庁", zh: "道政府" }
];

export function getTranslatedCenterName(center, lang = 'ko') {
  if (!center) return '';
  if (lang !== 'ko' && center.translatedName && center.translatedName[lang]) {
    return center.translatedName[lang];
  }
  return center.name || '';
}

export function getTranslatedAddress(center, lang = 'ko') {
  if (!center) return '';
  if (lang !== 'ko' && center.translatedAddress && center.translatedAddress[lang]) {
    return center.translatedAddress[lang];
  }
  return center.address || '';
}

export function getTranslatedLocationDesc(center, lang = 'ko') {
  if (!center) return '';
  if (lang !== 'ko' && center.translatedLocationDesc && center.translatedLocationDesc[lang]) {
    return center.translatedLocationDesc[lang];
  }
  return center.locationDesc || '';
}

export function getTranslatedClosedDays(center, lang = 'ko') {
  if (!center) return '';
  if (lang !== 'ko' && center.translatedClosedDays && center.translatedClosedDays[lang]) {
    return center.translatedClosedDays[lang];
  }
  return center.closedDays || (lang === 'ko' ? '연중무휴' : lang === 'en' ? 'Open Daily' : lang === 'ja' ? '年中無休' : '全年无休');
}

export function getTranslatedOperator(center, lang = 'ko') {
  if (!center) return '';
  const rawOp = (typeof center === 'object' ? center.operator : center) || '';
  if (lang === 'ko' || !rawOp) return rawOp;

  let op = rawOp;
  if (typeof center === 'object' && center.translatedOperator && center.translatedOperator[lang]) {
    op = center.translatedOperator[lang];
  }

  // Polish awkward romanization
  for (const item of OPERATOR_TERMS) {
    if (item.match.test(rawOp)) {
      const prov = PROVINCE_NAMES[center.province]?.[lang] || center.province || '';
      return `${prov} ${item[lang]}`.trim();
    }
  }

  return op;
}

export function getTranslatedServices(center, lang = 'ko') {
  if (!center) return '';
  const rawServices = center.services || '';
  if (lang === 'ko' || !rawServices) return rawServices;

  // Extract clean recognized tags
  const matchedTags = [];
  for (const item of SERVICE_DICTIONARY) {
    if (item.match.test(rawServices) || (center.translatedServices && center.translatedServices.en && item.match.test(center.translatedServices.en))) {
      if (!matchedTags.includes(item[lang])) {
        matchedTags.push(item[lang]);
      }
    }
  }

  if (matchedTags.length > 0) {
    return matchedTags.join(', ');
  }

  if (center.translatedServices && center.translatedServices[lang]) {
    return center.translatedServices[lang];
  }
  return rawServices;
}
